module.exports = __webpack_public_path__ + "static/img/IMG_20150307_170926.1bd78d31.jpg";